import React from 'react';

function TaskTabPlaceholder({ label }) {
  return (
    <div className="rounded-3xl border border-dashed border-line bg-surface/60 p-10 text-center">
      <p className="text-lg font-medium text-content">{label}</p>
      <p className="mt-2 text-sm text-content-muted">
        En construcción
      </p>
    </div>
  );
}

export default TaskTabPlaceholder;
